import { useDrawIn } from "./useDrawIn.js";

const FILL_MS = 700;
const CAP_MS = 250;
const STAGGER_MS = 70;
const TOTAL_MS = FILL_MS + CAP_MS;
const linear = (t) => t;

// CSS bezier easing is y at the parameter whose x equals elapsed progress,
// not simply y(elapsed). Bisection keeps the reference curve deterministic.
function bezier(t, x1, y1, x2, y2) {
  if (t <= 0) return 0;
  if (t >= 1) return 1;
  const coordinate = (u, a, b) =>
    3 * (1 - u) ** 2 * u * a + 3 * (1 - u) * u ** 2 * b + u ** 3;
  let lo = 0;
  let hi = 1;
  for (let i = 0; i < 20; i += 1) {
    const mid = (lo + hi) / 2;
    if (coordinate(mid, x1, x2) < t) lo = mid;
    else hi = mid;
  }
  return coordinate((lo + hi) / 2, y1, y2);
}

// One clock ties the cap fade to fill completion; no independent timeout can
// show the cap early. Mount identity owns timing, not the current sort index.
export function useRunwayEntrance(index = 0) {
  const elapsed = useDrawIn(index, {
    duration: TOTAL_MS,
    stagger: STAGGER_MS,
    easing: linear,
    observeReducedMotion: true,
  }) * TOTAL_MS;
  return {
    fill: bezier(elapsed / FILL_MS, 0.22, 0.61, 0.36, 1),
    cap: bezier((elapsed - FILL_MS) / CAP_MS, 0.25, 0.1, 0.25, 1),
  };
}
